/********************************************************************************
 * Copyright (c) 2022 Cedalo GmbH
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License 2.0 which accompany this distribution.
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *   https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const CellRange = require('../CellRange');

const getRowIndexFromRef = (ref) => ref.row - 1;
const getColIndexFromRef = (ref) => {
	const { col } = ref;
	if (col === 'COMMENT') return 0;
	if (col === 'IF') return 1;
	return CellRange.getColumnFromString(col) + 1;
};
const getRefColFromIndex = (col, sheet) => CellRange.getColumnStringFromIndex(col + sheet.colOffset, sheet);

const getColIndex = (col) => getColIndexFromRef(col.ref);
const getRefFromColIndex = (col, sheet) => ({ col: getRefColFromIndex(col, sheet) });

const getRowIndex = (row) => getRowIndexFromRef(row.ref);
const getRefFromRowIndex = (row) => ({ row: row + 1 });

const getPosFromRef = (ref) => ({ x: getColIndexFromRef(ref), y: getRowIndexFromRef(ref) });
const getRefFromPos = (x, y, sheet) => ({ col: getRefColFromIndex(x, sheet), row: y + 1 });

module.exports = {
	getColIndex,
	getColIndexFromRef,
	getRefFromColIndex,
	getRowIndex,
	getRowIndexFromRef,
	getRefFromRowIndex,
	getPosFromRef,
	getRefFromPos
};
